import React from 'react';
import { Box, Typography, Card, CardContent, Divider, TextField, Grid } from '@mui/material';

function SalesActionStatDetailCard({ selectedDetail }) {

    const handleProjectClick = (selectedDetail) => {
        if (!selectedDetail || !selectedDetail.prjUuid || String(selectedDetail.prjUuid).trim() === '' || String(selectedDetail.prjUuid) === 'null') return;

        let pageUrl = "/chancemng";

        const status = selectedDetail.cmpStatus;
        const hasStatus = status !== null && status !== undefined && String(status).trim() !== '' && String(status) !== 'null';

        let stepTarget = (selectedDetail.cstGrade !== null && selectedDetail.cstGrade !== undefined && String(selectedDetail.cstGrade) !== 'null') ? selectedDetail.cstGrade : '0';
        if (hasStatus) {
            if (String(selectedDetail.prjTyp).trim() === 'N') {
                pageUrl = "/projectmng";
            } else {
                pageUrl = "/maintancetmng";
            }
            stepTarget = (selectedDetail.cmpGrade !== null && selectedDetail.cmpGrade !== undefined && String(selectedDetail.cmpGrade) !== 'null') ? selectedDetail.cmpGrade : '0';
        }
        
        window.open(`${pageUrl}/${selectedDetail.prjUuid}/${stepTarget}/1`, '_blank');
    };

  const inputStyle = {
    '& .MuiInputBase-input': { fontSize: '13px', color: '#1F2937', fontWeight: '500' },
    '& .MuiInputLabel-root': { fontSize: '13px' },
    backgroundColor: '#ffffff'
  };

  const textareaStyle = {
    '& .MuiInputBase-input': { fontSize: '13px', color: '#374151', lineHeight: '1.6' },
    '& .MuiInputLabel-root': { fontSize: '13px' },
    backgroundColor: '#ffffff'
  };

  return (
    <Card 
      elevation={0}
      sx={{ 
        borderRadius: '12px', 
        border: '1px solid rgba(0, 0, 0, 0.08)', 
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
        backgroundColor: '#ffffff',
        minHeight: 280,
        height: '100%',
        mt: 0 
      }}
    >
      <CardContent sx={{ p: 2, display: 'flex', flexDirection: 'column', gap: 1.2, height: '100%', boxSizing: 'border-box' }}>

        <Typography variant="subtitle1" sx={{ fontWeight: '600', color: '#111827' }}>
          상세 내역
        </Typography>
        <Divider sx={{ mb: 0.5 }} />
        
        {selectedDetail ? (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField fullWidth size="small" label="제목" value={selectedDetail.title || '-'} InputProps={{ readOnly: true }} sx={inputStyle} focused={false} />
            </Grid>

            <Grid item xs={6}>
              <TextField fullWidth size="small" label="업무구분" value={selectedDetail.actionName || '-'} InputProps={{ readOnly: true }} sx={inputStyle} focused={false} />
            </Grid>
            <Grid item xs={6}>
              <TextField fullWidth size="small" label="담당자명" value={selectedDetail.usrNm || '-'} InputProps={{ readOnly: true }} sx={inputStyle} focused={false} />
            </Grid>

            <Grid item xs={6}>
              <TextField fullWidth size="small" label="시작 시간" value={selectedDetail.startDatetime ? selectedDetail.startDatetime.substring(0, 16) : '-'} InputProps={{ readOnly: true }} sx={inputStyle} focused={false} />
            </Grid>
            <Grid item xs={6}>
              <TextField fullWidth size="small" label="종료 시간" value={selectedDetail.endDatetime ? selectedDetail.endDatetime.substring(0, 16) : '-'} InputProps={{ readOnly: true }} sx={inputStyle} focused={false} />
            </Grid>

            <Grid item xs={6}>
              <TextField fullWidth size="small" label="업체명" value={selectedDetail.companyNm || '-'} InputProps={{ readOnly: true }} sx={inputStyle} focused={false} />
            </Grid>
            <Grid item xs={6}>
              <TextField fullWidth size="small" label="장소" value={selectedDetail.meetPlace || '-'} InputProps={{ readOnly: true }} sx={inputStyle} focused={false} />
            </Grid>

            <Grid item xs={12}>
              <TextField 
                  fullWidth 
                  size="small" 
                  label="사업명" 
                  // 💡 [값 주입 조건부 처리]: 공식 사업명(cstNm)이 있으면 그걸 보여주고, 없으면 수동 입력했던 값(customProjectNm)을 보여줍니다.
                  value={selectedDetail.cstNm || selectedDetail.customProjectNm || ''} 
                  InputProps={{ readOnly: true }} 
                  focused={false} 
                  
                  // 💡 [클릭 이동 분기]: 공식 사업(prjUuid가 존재)일 때만 링크 이동 함수를 실행하고, 수동 입력일 때는 클릭을 막습니다.
                  onClick={() => {
                      if (selectedDetail.prjUuid && typeof handleProjectClick === 'function') {
                          handleProjectClick(selectedDetail);
                      }
                  }}
                  
                  sx={{
                    '& .MuiOutlinedInput-root': { borderRadius: '6px' },
                    '& .MuiInputLabel-root': { fontSize: '13px' },
                    '& .MuiInputBase-input': {
                        fontSize: '13px',
                        backgroundColor: '#ffffff',
                        
                        // 🎯 [상세보기 스타일 동적 분기]
                        // 공식 사업(prjUuid 존재)이면 파란색 밑줄 링크 스타일, 수동 입력이면 클릭할 필요 없는 일반 검정색 단색 스타일로 바꿉니다.
                        cursor: selectedDetail.prjUuid ? 'pointer !important' : 'default !important',
                        color: selectedDetail.prjUuid ? '#228be6 !important' : '#333333 !important', 
                        fontWeight: selectedDetail.prjUuid ? '600 !important' : '500 !important',
                        textDecoration: selectedDetail.prjUuid ? 'underline !important' : 'none !important',
                        WebkitTextFillColor: selectedDetail.prjUuid ? '#228be6 !important' : '#333333 !important',
                        pointerEvents: selectedDetail.prjUuid ? 'auto !important' : 'none !important'
                    }
                  }} 
              />
          </Grid>
             <Grid item xs={12}>
              <TextField fullWidth size="small" label="제품" value={selectedDetail.productNm || '-'} InputProps={{ readOnly: true }} sx={inputStyle} focused={false} />
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth multiline rows={20} size="small" label="상세 내용" value={selectedDetail.actionContent || '-'} InputProps={{ readOnly: true }} sx={textareaStyle} focused={false} />
            </Grid>
          </Grid>
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexGrow: 1, minHeight: 690 }}>
            <Typography variant="body2" color="text.disabled" sx={{ textAlign: 'center', lineHeight: 1.6 }}>
              테이블의 행을 클릭하면<br />상세 입력 폼 형태 리포트가<br />여기에 표시됩니다.
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
}

export default SalesActionStatDetailCard;
